import { Flex } from 'antd';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
  ChartOptions
} from 'chart.js';
import { useMemo } from 'react';
import { Line } from 'react-chartjs-2';
import { useTranslation } from 'react-i18next';
import { useTheme } from 'styled-components';

import { EIconType } from '@/components/Icon';
import { useMyQuizzesEvolutionByDateRank } from '@/store/quizzes/quiz-results/useMyQuizzesEvolutionByDateRank';
ChartJS.register(CategoryScale, LinearScale, PointElement, LineElement, Title, Tooltip, Legend);

const OPTIONS: ChartOptions<'line'> = {
  responsive: true,
  maintainAspectRatio: false,
  scales: {
    y: {
      min: 0,
      max: 100,
      ticks: {
        callback: value => `${value}%`,
        stepSize: 20
      },
      afterDataLimits: scale => {
        scale.max = scale.max * 0.8;
      }
    },
    x: {
      ticks: {
        maxRotation: 0,
        minRotation: 0
      }
    }
  },
  plugins: {
    legend: {
      display: false
    },
    tooltip: {
      callbacks: {
        label: context => `${context.dataset.label}: ${(context.raw as number).toFixed(2)}%`
      }
    }
  }
};

export const QuizEvolutionGraph = () => {
  const { t } = useTranslation('StudentQuizzesTranslations');
  const { colors } = useTheme();
  const { data: dataQuizEvolution } = useMyQuizzesEvolutionByDateRank();

  const statsData: {
    labels: string[];
    datasets: {
      label: string;
      data: number[];
      borderColor: string;
      backgroundColor: string;
      tension: number;
      pointRadius: number;
      pointHoverRadius: number;
      icon: EIconType;
    }[];
  } = useMemo(
    () => ({
      labels: dataQuizEvolution.labels,
      datasets: [
        {
          label: t('CORRECTS'),
          data: dataQuizEvolution.correct,
          borderColor: colors.green6,
          backgroundColor: colors.green6,
          tension: 0.4,
          pointRadius: 5,
          pointHoverRadius: 6,
          icon: 'CheckmarkFilled'
        },
        {
          label: t('WRONGS'),
          data: dataQuizEvolution.wrong,
          borderColor: colors.red6,
          backgroundColor: colors.red6,
          tension: 0.4,
          pointRadius: 5,
          pointHoverRadius: 6,
          icon: 'CloseFilled'
        },
        {
          label: t('BLANKS'),
          data: dataQuizEvolution.blank,
          borderColor: colors.black5,
          backgroundColor: colors.black5,
          tension: 0.4,
          pointRadius: 5,
          pointHoverRadius: 6,
          icon: 'CircleDash'
        }
      ]
    }),
    [colors, t, dataQuizEvolution]
  );

  return (
    <Flex style={{ height: 350, width: '100%', overflow: 'hidden' }}>
      <Line options={OPTIONS} data={statsData} />
    </Flex>
  );
};
